import chatGradientIcon from 'icons/chat-outline-gradient.svg';
import mouthGradientIcon from 'icons/face-mouth-closed-outline-gradient.svg';
import starGradientIcon from 'icons/star-outline-gradient.svg';

import messages from './messages';

export const benefits = [
	{
		icon: starGradientIcon,
		heading: messages.item1Heading,
		description: messages.item1Description,
		headingAccept: messages.item1HeadingAccept,
		descriptionAccept: messages.item1DescriptionAccept,
	},
	{
		icon: mouthGradientIcon,
		heading: messages.item2Heading,
		description: messages.item2Description,
		headingAccept: messages.item2HeadingAccept,
		descriptionAccept: messages.item2DescriptionAccept,
	},
	{
		icon: chatGradientIcon,
		heading: messages.item3Heading,
		description: messages.item3Description,
		headingAccept: messages.item3HeadingAccept,
		descriptionAccept: messages.item3DescriptionAccept,
	},
];
